<template>
  <div v-if="organization.hasOwnProperty('id')">
    <div class="row">
      <div class="col-md-10">
        <b-card
          no-body
        >
          <div class="m-2">
            <div class="row">
              <div class="col-6">

                <table class="mt-2 mt-xl-0 w-100">
                  <tr>
                    <th>{{ $t('Higher organization') }}</th>
                    <td v-if="organization.parent">
                      {{ organization.parent[$i18n.locale] }}
                    </td>
                  </tr>
                  <tr>
                    <th>{{ $t('Type organization') }}</th>
                    <td v-if="organization.type_org">
                      {{ organization.type_org[$i18n.locale] }}
                    </td>
                  </tr>
                  <tr>
                    <th>{{ $t('Region') }}</th>
                    <td v-if="organization.region_name">
                      {{ organization.region_name.name[$i18n.locale] }}
                    </td>
                  </tr>
                  <tr>
                    <th>{{ $t('name') }}</th>
                    <td> {{ organization.name[$i18n.locale] }} </td>
                  </tr>
                </table>
              </div>
              <div class="col-6">
                <table class="mt-2 mt-xl-0 w-100">
                  <tr>
                    <th>{{ $t('Address') }}</th>
                    <td> {{ organization.address }} </td>
                  </tr>
                  <tr>
                    <th>{{ $t('Telephone number') }}</th>
                    <td> {{ organization.tel }} </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </b-card>
      </div>
      <div class="col-md-2">
        <b-card
          no-body
        >
          <div class="m-2">
            <b-button
              v-if="$can('manage', 'All')"
              v-b-toggle.sidebar-create-direction
              variant="success"
              class="btn mb-75 btn-primary btn-block collapsed"
            >
              <feather-icon
                icon="PlusIcon"
                class="mr-50"
              />
              <span>{{ $t('Create') }}</span>
            </b-button>
          </div>
        </b-card>
      </div>
    </div>
    <direction />
  </div>

</template>

<script>
import {
  BButton, BCard, VBToggle,
} from 'bootstrap-vue'
import { onUnmounted } from '@vue/composition-api'
import organizationDirectionModule from '@/store/organization-direction/index'
import organizationModule from '@/store/organization/index'
import directionModule from '@/store/direction/index'
import store from '@/store'
import Direction from '@/views/pages/organization/direction/Direction.vue'

export default {
  directives: {
    'b-toggle': VBToggle,
  },
  components: {
    BCard,
    BButton,
    Direction,
  },
  computed: {
    organization() {
      return this.$store.state[this.MODULE_ORGANIZATION].organization
    },
  },
  created() {
    this.$store.dispatch(`${this.MODULE_ORGANIZATION}/get`, this.$route.params.id)
    this.$store.dispatch(`${this.MODULE_DIRECTION}/list`, { limit: 9999 })
  },
  methods: {
  },
  setup() {
    const MODULE_ORG_DIRECTION = 'organizationDirection'
    const MODULE_ORGANIZATION = 'organization'
    const MODULE_DIRECTION = 'direction'
    // Register module
    if (!store.hasModule(MODULE_ORGANIZATION)) store.registerModule(MODULE_ORGANIZATION, organizationModule)
    if (!store.hasModule(MODULE_ORG_DIRECTION)) store.registerModule(MODULE_ORG_DIRECTION, organizationDirectionModule)
    if (!store.hasModule(MODULE_DIRECTION)) store.registerModule(MODULE_DIRECTION, directionModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(MODULE_ORGANIZATION)) store.unregisterModule(MODULE_ORGANIZATION)
      if (store.hasModule(MODULE_ORG_DIRECTION)) store.unregisterModule(MODULE_ORG_DIRECTION)
      if (store.hasModule(MODULE_DIRECTION)) store.unregisterModule(MODULE_DIRECTION)
    })
    return {
      MODULE_ORGANIZATION,
      MODULE_ORG_DIRECTION,
      MODULE_DIRECTION,
    }
  },
}
</script>
